/*
 * 詳細画面パーツ
 * テキスト入力
 */
<template>
<tr class="tr-td-control tr-edit-text">
	<!-- タイトル -->
	<td v-if="r_disp_title" class="td-dataname">
		<div><!-- 空白除けコメントアウト
			-->{{r_title}}
			<!-- 必須表示 -->
			<div v-if="r_settings.edit_right && (r_is_require || r_is_display_require_text) && !r_is_not_display_require_text" class="layout-right">
				<font class="text-red">＊</font>
			</div>
			<!-- 変更箇所表示 -->
			<div v-if="m_isEdit" class="layout-right">
				<font class="text-red">*</font>
			</div>
		</div>
	</td>
	<!-- テキスト -->
	<td v-if="r_settings.edit_right" :class="td_data_class">
		<el-form class="text_code_area" :model="m_ruleForm" :rules="m_validationText" ref="valid_target">
			<div class="text_code">
				{{r_text_header}}
			</div><!-- 空白除けコメントアウト
			--><el-form-item prop="text" class="text_code disp-text" >
				<c-inputedit
					:r_disabled="r_disabled"
					:r_type="r_validattype"
					:r_max_length="max_length"
					:r_max_fra_length="max_fra_length"
					:r_input_class="createEditClassType(m_ruleForm.text)"
					:r_placeholder="r_placeholder"
					:r_data_change_check_str="r_data_change_check_str"
					:r_text_footer="r_text_footer"
					v-model="m_ruleForm.text"
					@input="onInputName"
					@blur="onBlur"
					@keyup.enter="onKeyup"
				></c-inputedit>
			</el-form-item>
		</el-form >
		<!-- フッター部スロット -->
		<slot name='footer_slot'></slot>
	</td>
	<td v-else class="td-data">
		<div class="text_code">
			{{r_text_header}}
		</div>
		<div :class="r_class">
			<font :class="{'text-red':m_isEdit}">
				{{m_ruleForm.text | addComma(r_add_comma)}}
			</font>
		</div>
		<div v-if="r_text_footer !== ''" class="footer-text">
			{{r_text_footer}}
		</div>
	</td>
</tr>
</template>
<script>
	/**
	 * 詳細画面パーツ.<br>
	 * メモ.<br>
	 * @module js\parts\DetailItemName
	 * @example
	 * <c-detailitemname
	 * 	:r_messages = "r_messages"
	 * 	:r_settings = "r_settings"
	 * 	:info="m_info"
	 * 	@keyup="keyup"
	 * >
	 * </c-detailitemname>
	 **/

	/**
	 * props 引数
	 * @param {string[]} r_messages - 表示文言
	 * @param {string[]} r_settings - 初期設定値
	 * @param {object} info - 編集するデータ
	 **/
const NUMBER = "number"; // 正数
const DECIMAL = "decimal"; // 小数
const TEXT = "text"; // テキスト
const PASSWORD = "password"; //パスワード
const PASSWORD2 = "password2"; //パスワード
const HALF_WIDTH = "half-width"; // 半角英数字のみ
const HALF_WIDTH_MARK = "half-width-mark"; // 半角英数字のみ
const TELEPHONE = "telephone"; // 電話番号
const READ_ONLY = "read-only"; // リードのみテキスト
const HIRAGANA = "hiragana";// ひらがな
const INTEGRAL_NUMBER = "integral_number"; // 整数(マイナス許容)
const IP_ADDRESS = "ip-address"; // IPアドレス
const TIME_TEXT = "time"; // 時刻(4桁)
	export default {
		mixins: [
			require('js/common/Edit.mixin.vue'),
			require('js/common/trEdit.mixin.vue'),
			// バリデーションミックスイン
			require('js/common/validate/common.mixin.vue'),
			require('js/common/validate/edit.mixin.vue'),
		],
		props:{
			'r_messages': {},
			'r_disp_title':{
				type:Boolean,
				default:true
			},//!< r_disp_titleタイトル<td>を非表示にしたい場合はfalseにする。
			'r_title': String,
			'r_validattype':{
				type:String,
				default: "text"
			},
			'r_placeholder': {
				type:String,
				default: ""
			},
			'r_max_length': {
				type:Number,
				default: 30
			},
			'r_code_max': {
				type:Number,
				default: 999999
			},
			'r_code_min': {
				type:Number,
				default: 1
			},
			'r_is_require':{
				type:null,
				default: false
			},
			'r_is_display_require_text': {
				type: Boolean,
				default: false
			},
			'r_is_not_display_require_text': {
				type: Boolean,
				default: false
			},
			'r_text_header': {
				type:String,
				default: ""
			},
			'r_text_footer': {
				type: String,
				default: ''
			},
			'r_add_comma': {
				// 数値をカンマ区切りで表示したい場合true
				type:null,
				default: false
			},
			'value': {},
			'r_validator':null,//!< validate 処理を変更したい場合に指定する。指定がなければデフォルトチェックが有効になる
			'r_data_change_check_str': {
				type: Boolean,
				default: false
			},
		},
		data: function () {
			var target = this;
			return{
				m_ruleForm: {text:""},
				m_max_length: this.r_max_length,
				m_validationText:{
					text: [
						{ required: this.r_is_require, message: this.r_messages.required,trigger:'no' }, // TODO
						{
							validator: (rule, value, callback) => {
								var errMessage = "";
								var fnValidate = (target.r_validator)?target.r_validator:target.validateType;
								var type = [target.CHKTYPE_TEXT];

								switch ( target.r_validattype ) {
									case NUMBER: // 正数
										type = [target.CHKTYPE_NUMBER,target.CHKTYPE_CODE];
										break;
									case DECIMAL: // 小数
										type = [target.CHKTYPE_DECLEN,target.CHKTYPE_CODE];
										break;
									case TELEPHONE:// 電話番号
										type = [target.CHKTYPE_TEL,target.CHKTYPE_TXTLEN];
										break;
									case HIRAGANA:// ひらがな
										type = [target.CHKTYPE_KANA];
										break;
									case TEXT: // テキスト
										type = [target.CHKTYPE_TEXT,target.CHKTYPE_TXTLEN];
										break;
									case "":
									case PASSWORD: //パスワード
									case HALF_WIDTH: // 半角テキストのみ
										type = [target.CHKTYPE_ALPHANUM,target.CHKTYPE_TXTLEN];
										break;
									case PASSWORD2: //パスワード
									case HALF_WIDTH_MARK: // 半角英数字記号のみ
										type = [target.CHKTYPE_HALF,target.CHKTYPE_TXTLEN];
										break;
									case IP_ADDRESS: // IPアドレス
										type = [target.CHKTYPE_IP_ADDRESS];
										break;
									case INTEGRAL_NUMBER: // 整数(マイナス許容)
										type = [target.CHKTYPE_INTEGRAL_NUMBER,target.CHKTYPE_CODE];
										break;
									case TIME_TEXT: // 時刻(4桁)
										type = [target.CHKTYPE_NUMBER,target.CHKTYPE_TIME];
										break;
									default:
										break;
								}
								errMessage = fnValidate(type,
														value,
														target.r_code_max,
														target.r_code_min,
														target.r_max_length);

								if ( errMessage.length > 0 ) {
									callback(new Error(errMessage));
								} else {
									callback();
								}
							},
							trigger: ''
						}
					],
				}
			}
		},
		created: function() {
			this.m_ruleForm.text = this.value;
		},
		/**
		 * @instance
		 **/
		computed: {
			max_length: function(){
				switch ( this.r_validattype ) {
					case NUMBER: // 正数
					case DECIMAL: // 小数
					case INTEGRAL_NUMBER: // 整数
					case TIME_TEXT: // 時刻(4桁)
						var str = this.r_code_max.toString().split('.');
						if ( str[0] ) {
							return str[0].length;
						}
						break;
				}
				return this.r_max_length;
			},
			max_fra_length: function(){
				switch ( this.r_validattype ) {
					case NUMBER: // 正数
					case DECIMAL: // 小数
						var str = this.r_code_max.toString().split('.');
						if ( str[1] ) {
							return str[1].length;
						}
						break;
				}
				return 0;
			},
			td_data_class:function(){
				return this.r_disp_title ? 'td-data' : 'td-data-inner';
			},
		},
		watch:{
			value: function(val){
				this.m_ruleForm.text = val;
			},
			r_is_require: function(a, b){
				this.m_validationText.text[0].required = a;
			}
		},
		methods: {
			onInputName: function( val ){
				this.m_isChange = true;
			 	this.$emit('input', val);
				this.$emit('event_change');
			},
		},
		/**
		 * ファイル内で使用しているコンポーネント <br>
		 * cはグローバルコンポーネント(宣言は親のjsファイルで行っている)<br>
		 * @prop {component} c-inputname - 文字入力
		 * @instance
		 **/
		components: {
		},
		filters: {
			addComma: function (value, flag) {
				if( value !== ""  && value !== undefined && flag ) {
					return value.toLocaleString();
				}
				return value;
			}
		},
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/parts_com/TR/editText.vue